import { TrackingPageModel } from '../tracking-page.model';
import { getAsset, getProductItems } from './helpers';
import {
  getFontConfig,
  getSocialIcons,
  getFooterItems,
  getLogo,
  getLanguageMenu,
  white
} from './helpers';

export const kitchenware: TrackingPageModel = {
  languageMenu: getLanguageMenu('Montserrat', '#191d28ff'),
  searchPageInput: {
    backgroundColor: '#ffffff',
    borderColor: '#ced4da',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#6d788c')
  },
  searchPageTitle: {
    fontSize: 25,
    ...getFontConfig('Roboto Condensed', '#1a1e29ff', '700')
  },
  background: {
    color: white,
    useBackgroundImage: true,
    imageUrl: getAsset('/images/themes/kitchenware.jpg'),
    backgroundMode: 'cover',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat'
  },
  card: {
    backgroundColor: '#ffffff',
    linksColor: '#b91d00ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    trackingNumberField: 'trackingNumber',
    ...getFontConfig('Montserrat', '#1a1e29ff')
  },
  orderCard: {
    backgroundColor: '#ffffffff',
    linksColor: '#5780ff',
    linksUnderline: false,
    headerBackground: '#ffffff',
    footerBackground: '#ffffff',
    borderColor: '#ffffffff',
    borderRadius: 0,
    borderWidth: 1,
    shadow: 'none',
    ...getFontConfig('Ubuntu', '#2E4068')
  },
  orderNumber: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Roboto Condensed"', '#f5341dff', '700italic')
  },
  orderStatus: {
    alignment: 'center',
    fontSize: 18,
    ...getFontConfig('Montserrat', '#1a1e29ff', '300')
  },
  orderLastUpdated: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto Condensed', '#565656ff')
  },
  notYetShippedItemsTitle: {
    alignment: 'center',
    fontSize: 15,
    ...getFontConfig('Roboto Mono', '#f5341dff')
  },
  orderStatusOn: true,
  orderNumberOn: true,
  orderLastUpdatedOn: true,
  orderItemsFrame: {
    on: true,
    scroll: false,
    itemsLimit: 1,
    borderColor: '#f0f0f0ff',
    borderWidth: 1,
    borderRadius: 0,
    backgroundColor: '#ffffffff',
    shadow: 'none',
    button: {
      on: true,
      backgroundColor: '#21232bff',
      borderColor: '#2E4068',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      ...getFontConfig('Montserrat', white, '700')
    },
    itemCard: {
      backgroundColor: '#ffffffff',
      borderColor: '#2E4068',
      borderRadius: 0,
      borderWidth: 0,
      shadow: 'none',
      title: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Montserrat', '#1a1e29ff')
      },
      info: {
        alignment: 'left',
        fontSize: 14,
        ...getFontConfig('Roboto Condensed', '#000000ff', '700italic')
      },
      showAttributes: false
    }
  },
  searchButton: {
    on: true,
    backgroundColor: '#d80000ff',
    borderColor: '#2e406800',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Montserrat', '#ffffffff', '700')
  },
  detailsButton: {
    backgroundColor: '#d80000ff',
    borderColor: '#5780ff',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto Condensed', white, '700')
  },
  trackButton: {
    backgroundColor: '#9e1d00ff',
    borderColor: '#ee7227',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    ...getFontConfig('Roboto Condensed', white, '700')
  },
  pageScroll: {
    scrollColor: '#2E4068',
    borderRadius: 2,
    backgroundColor: '#ffffff00'
  },
  scripts: {
    head: null,
    body: null
  },
  logo: getLogo(getAsset('/images/themes/kitchenware-logo.png')),
  socialIcons: getSocialIcons('#362727ff'),
  sidebar: {
    parcelIcon: 'icon-parcel',
    groupIcon: 'icon-track_number',
    backgroundColor: '#ffffffff',
    borderColor: '#CED2DC',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    sidebarField: null,
    ...getFontConfig('Montserrat', '#1b1b1bff')
  },
  footer: {
    hideTrackmageBranding: false,
    backgroundColor: '#ffffff80',
    linksColor: '#e80000ff',
    linksUnderline: false,
    ...getFooterItems(),
    ...getFontConfig('Montserrat', '#2f2f2fff')
  },
  header: {
    backgroundColor: '#ffffffa5'
  },
  faviconUrl: '/assets/favicon/favicon-32x32.png',
  sidebarProductsFeed: {
    on: false,
    backgroundColor: '#ffffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 5,
      shadow: 'none',
      button: {
        backgroundColor: '#d80000ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Montserrat', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Montserrat', '#1a1e29ff')
      },
      regularPrice: {
        alignment: 'left',
        fontSize: 10,
        ...getFontConfig('Roboto Condensed', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto Condensed', '#bc2200ff', '700italic')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('kitchenware'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#f52e1dff',
      arrowSize: 35
    }
  },
  mainProductsFeed: {
    on: true,
    backgroundColor: '#ffffffff',
    borderColor: '#d5d9e1',
    borderRadius: 0,
    borderWidth: 0,
    shadow: 'none',
    card: {
      backgroundColor: '#ffffffff',
      borderColor: '#ffffff',
      borderRadius: 0,
      borderWidth: 5,
      shadow: 'none',
      button: {
        backgroundColor: '#d80000ff',
        borderColor: '#5780ff',
        borderRadius: 0,
        borderWidth: 0,
        shadow: 'none',
        ...getFontConfig('Montserrat', white, '700')
      },
      buttonText: 'BUY NOW',
      title: {
        alignment: 'left',
        fontSize: 15,
        ...getFontConfig('Montserrat', '#1a1e29ff')
      },
      regularPrice: {
        alignment: 'left',
        fontSize: 10,
        ...getFontConfig('Roboto Condensed', '#828282')
      },
      discountedPrice: {
        alignment: 'center',
        fontSize: 15,
        ...getFontConfig('Roboto Condensed', '#bc2200ff', '700italic')
      },
      imageBorderRadius: 0,
      imageHeight: 120,
      imageWidth: 120
    },
    feedUrl: '',
    productItems: getProductItems('kitchenware'),
    sliderOptions: {
      autoplay: true,
      autoplayDelay: 3000,
      loop: true,
      arrowColor: '#f52e1dff',
      arrowSize: 35
    }
  },
  seoTitle: ''
};
